import { render, staticRenderFns } from "./CustomerReminderListFilter.vue?vue&type=template&id=3afd0994&"
import script from "./CustomerReminderListFilter.vue?vue&type=script&lang=js&"
export * from "./CustomerReminderListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports